import { render } from "./DesktopAppView.vue?vue&type=template&id=086c7162&scoped=true"
import script from "./DesktopAppView.vue?vue&type=script&lang=js"
export * from "./DesktopAppView.vue?vue&type=script&lang=js"

import "./DesktopAppView.vue?vue&type=style&index=0&id=086c7162&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086c7162"]])

export default __exports__